(() => {
  const config = document.getElementById('ch-tolstoy-locale');
  if (!config) return;
  const { locale, root, labels } = JSON.parse(config.textContent);
  const georgian = locale === 'ka';
  const selector = 'tolstoy-widget';
  const queue = new Set();
  let scheduled = false;
  function productUrl(raw) {
    try {
      const url = new URL(raw, location.origin);
      if (![location.hostname, 'corsethouse.com', 'www.corsethouse.com', 'corset-5673.myshopify.com'].includes(url.hostname)) return null;
      const match = url.pathname.match(/^\/(?:ka\/)?(products\/[^/]+\/?$)/);
      if (!match) return null;
      url.protocol = location.protocol;
      url.host = location.host;
      url.pathname = `${root.replace(/\/$/, '')}/${match[1]}`;
      return url.href;
    } catch { return null; }
  }
  function translated(value) {
    if (!value) return value;
    const trimmed = value.trim();
    if (labels[trimmed]) return value.replace(trimmed, labels[trimmed]);
    if (/^GEL\s*[\d,.]+$/.test(trimmed)) return value.replace(trimmed, `${trimmed.replace(/^GEL\s*/, '')} ₾`);
    if (!georgian) return value;
    for (const prefix of ['Open story: ', 'Play: ']) {
      if (trimmed.startsWith(prefix)) return `${labels['Play']}: ${trimmed.slice(prefix.length)}`;
    }
    if (trimmed.startsWith('Open ') && trimmed.endsWith(' in player')) return `${labels['Play']}: ${trimmed.slice(5, -10)}`;
    return value;
  }
  function adapt(widget) {
    if (!widget.isConnected) return;
    widget.querySelectorAll('a[href]').forEach(link => {
      const localized = productUrl(link.getAttribute('href'));
      if (localized && link.href !== localized) link.setAttribute('href', localized);
      if (localized && link.target !== '_top') link.target = '_top';
    });
    widget.querySelectorAll('[aria-label],[title]').forEach(element => {
      for (const attribute of ['aria-label', 'title']) {
        const original = element.getAttribute(attribute);
        const result = translated(original);
        if (result !== original) element.setAttribute(attribute, result);
      }
    });
    const walker = document.createTreeWalker(widget, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) {
      const node = walker.currentNode;
      if (node.parentElement.closest('script,style')) continue;
      const result = translated(node.nodeValue);
      if (result !== node.nodeValue) node.nodeValue = result;
    }
  }
  function enqueue(node) {
    const element = node.nodeType === Node.ELEMENT_NODE ? node : node.parentElement;
    if (!element) return;
    const widget = element.closest(selector);
    if (widget) queue.add(widget);
    element.querySelectorAll?.(selector).forEach(item => queue.add(item));
    if (!queue.size || scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      const widgets = [...queue];
      queue.clear();
      widgets.forEach(adapt);
    });
  }
  document.addEventListener('click', event => {
    if (!georgian) return;
    const path = event.composedPath();
    if (!path.some(node => node instanceof Element && node.matches(selector))) return;
    const link = path.find(node => node instanceof HTMLAnchorElement);
    if (!link) return;
    const localized = productUrl(link.getAttribute('href'));
    if (!localized) return;
    link.href = localized;
    link.target = '_top';
    event.stopImmediatePropagation();
  }, true);
  const observer = new MutationObserver(records => {
    records.forEach(record => {
      if (record.type === 'childList') record.addedNodes.forEach(enqueue);
      else enqueue(record.target);
    });
  });
  observer.observe(document.body, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['href', 'aria-label', 'title'] });
  enqueue(document.body);
})();
